import { getDaysInMonth, max, min } from 'date-fns';

export interface DateBounds {
  start?: Date;
  end?: Date;
}

/** Keeps the day of month (capped to the target month's length) and clamps to `start`/`end`. */
export function moveDateToMonth(
  date: Date,
  month: Date,
  { start, end }: DateBounds = {},
): Date {
  const day = Math.min(date.getDate(), getDaysInMonth(month));
  const moved = new Date(month.getFullYear(), month.getMonth(), day);
  const atLeastStart = start ? max([moved, start]) : moved;
  return end ? min([atLeastStart, end]) : atLeastStart;
}
